module.exports = __webpack_public_path__ + "img/10979926_L.f0755e68.png";